var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clearfix" },
    [
      _c(
        "div",
        {
          staticClass: "floL",
          class: { marTML: _vm.rowIdx > 0 },
          attrs: { id: _vm.getActivityAreaId(_vm.leftSide) + "-normal" }
        },
        [
          _c(
            "p",
            {
              staticClass: "fntH6 fntL bold padBSM",
              staticStyle: { color: "#2c2c2c" }
            },
            [_vm._v(_vm._s(_vm.leftSide.name) + "님의 액티비티")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "amway-theme" }, [
            _c(
              "div",
              {
                staticClass: "radio-wrapper NCAcmi_cont03_radio NCAcmi_radioBtn"
              },
              [
                _vm._l(_vm.normalExamples, function(example) {
                  return _c("SurveyActivityExample", {
                    key: "row" + _vm.rowIdx + "_left_" + example.se_code,
                    attrs: {
                      examples: _vm.normalExamples,
                      example: example,
                      attendant: _vm.leftSide,
                      unique: _vm.sqCode + "_row" + _vm.rowIdx + "_left"
                    }
                  })
                }),
                _vm._v(" "),
                _c("SurveyActivityExample", {
                  attrs: {
                    examples: _vm.normalExamples,
                    example: _vm.noneExample,
                    attendant: _vm.leftSide,
                    unique: _vm.sqCode + "_row" + _vm.rowIdx + "_left"
                  }
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.showVipExamples(_vm.leftSide)
            ? [
                _c("hr", {
                  staticStyle: { "border-bottom": "1px dashed #e3e3e3" }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "fntH6 fntL bold padBSM",
                    staticStyle: { color: "#2c2c2c" },
                    attrs: { id: _vm.getActivityAreaId(_vm.leftSide) + "-vip" }
                  },
                  [_vm._v("VIP 전용 액티비티")]
                ),
                _vm._v(" "),
                _vm._l(_vm.vipExamples, function(example, vipIdx) {
                  return _c("SurveyActivityExampleVip", {
                    key: "row" + _vm.rowIdx + "_left_vip_" + example.se_code,
                    attrs: {
                      example: example,
                      attendant: _vm.leftSide,
                      unique:
                        "row" + _vm.rowIdx + "_left_vip_" + example.se_code,
                      "is-top": vipIdx === 0
                    }
                  })
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.rightSide
        ? [
            _c("hr", {
              staticClass: "moOnly",
              staticStyle: { "border-top": "1px solid #e3e3e3" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "floR",
                class: { marTML: _vm.rowIdx > 0 },
                attrs: { id: _vm.getActivityAreaId(_vm.rightSide) + "-normal" }
              },
              [
                _c(
                  "p",
                  {
                    staticClass: "fntH6 fntL bold padBSM",
                    staticStyle: { color: "#2c2c2c" }
                  },
                  [_vm._v(_vm._s(_vm.rightSide.name) + "님의 액티비티")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "amway-theme" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "radio-wrapper NCAcmi_cont03_radio NCAcmi_radioBtn"
                    },
                    [
                      _vm._l(_vm.normalExamples, function(example) {
                        return _c("SurveyActivityExample", {
                          key: "row" + _vm.rowIdx + "_right_" + example.se_code,
                          attrs: {
                            examples: _vm.normalExamples,
                            example: example,
                            attendant: _vm.rightSide,
                            unique: _vm.sqCode + "_row" + _vm.rowIdx + "_right"
                          }
                        })
                      }),
                      _vm._v(" "),
                      _c("SurveyActivityExample", {
                        attrs: {
                          examples: _vm.normalExamples,
                          example: _vm.noneExample,
                          attendant: _vm.rightSide,
                          unique: _vm.sqCode + "_row" + _vm.rowIdx + "_right"
                        }
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _vm.showVipExamples(_vm.rightSide)
                  ? [
                      _c("hr", {
                        staticStyle: { "border-bottom": "1px dashed #e3e3e3" }
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "fntH6 fntL bold padBSM",
                          staticStyle: { color: "#2c2c2c" },
                          attrs: {
                            id: _vm.getActivityAreaId(_vm.rightSide) + "-vip"
                          }
                        },
                        [_vm._v("VIP 전용 액티비티")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.vipExamples, function(example, vipIdx) {
                        return _c("SurveyActivityExampleVip", {
                          key:
                            "row" +
                            _vm.rowIdx +
                            "_right_vip_" +
                            example.se_code,
                          attrs: {
                            example: example,
                            attendant: _vm.rightSide,
                            unique:
                              "row" +
                              _vm.rowIdx +
                              "_right_vip_" +
                              example.se_code,
                            "is-top": vipIdx === 0
                          }
                        })
                      })
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm.showBottomHr
              ? _c("hr", {
                  staticClass: "moOnly",
                  staticStyle: { "border-top": "1px solid #e3e3e3" }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56ddd6db", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56ddd6db","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey2/components/SurveyActivityPair.vue
// module id = null
// module chunks = 